import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

/** Values come from .env.local — see SETUP.md. Vite only exposes VITE_* keys. */
const cfg = {
  apiKey:            import.meta.env.VITE_FB_API_KEY,
  authDomain:        import.meta.env.VITE_FB_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FB_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FB_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FB_SENDER_ID,
  appId:             import.meta.env.VITE_FB_APP_ID,
};

export const isConfigured = Boolean(cfg.apiKey && cfg.projectId);

const app = isConfigured ? initializeApp(cfg) : null;

/**
 * Firestore with a persistent local cache (IndexedDB), shared across tabs. A
 * tech in a basement with one bar opens the link and sees the list they had,
 * taps Done, and the write queues until the signal comes back — instead of a
 * blank page and a spinner. Reads come from the cache first, then the server.
 * Where IndexedDB is unavailable (some private windows) the SDK falls back to
 * memory on its own.
 */
function firestore() {
  if (!app) return null as any;
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
    });
  } catch {
    return initializeFirestore(app, {});
  }
}

export const auth = app ? getAuth(app) : (null as any);
export const dbf  = firestore();
export const stor = app ? getStorage(app) : (null as any);
